import React, {PropTypes} from 'react';
import {FormattedNumber} from 'react-intl';
import {GridList, GridTile} from 'material-ui/GridList';
import RaisedButton from 'material-ui/RaisedButton';
import {ListProps} from '../../../utilites/helpers/crudListHelper';
import LoadingSpinner from '../../LoadingSpinner';
import FetchDataComponent from '../../common/FetchDataComponent';

class ProductGridList extends FetchDataComponent {
  static propTypes = Object.assign({}, ListProps, ...FetchDataComponent.propTypes,{
    onSelect: PropTypes.func.isRequired
  });
  
  onSelectItem(item) {
    this.props.onSelect(item);
  }

  render() {
    let {items, loading} = this.props;

    return (
      <LoadingSpinner show={loading}>
        <GridList
          padding={24}
          cellHeight={300}
          cols={4}
        >
          {items.map((product, key) => ((
            <GridTile key={key}>
              <div style={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between'
              }}>
                {this._renderProductItem(product)}
                <div>
                  <RaisedButton label="Add"
                                style={{width: '100%'}}
                                secondary={true}
                                onClick={() => this.onSelectItem(product)}/>
                </div>
              </div>
            </GridTile>
          )))}
        </GridList>
      </LoadingSpinner>
    );
  }

  _renderProductItem({name, details: {price, pictures}}) {
    return (
      <div style={{
        paddingBottom: 15,
        paddingTop: 15,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <div>
          <img src={pictures[0]} alt={name}
               style={{maxWidth: '100%', maxHeight: '162px'}}/>
        </div>
        <div style={{textAlign: 'center'}}>
          <strong style={{}}>{name}</strong>
        </div>
        <div style={{textAlign: 'center'}}>
          <span style={{fontSize: 16}}>
            {price.currency}
          </span>
          &nbsp;
          <span style={{color: '#df991f', fontSize: 26}}>
            <FormattedNumber
              value={price.amount}
              format="currency"
            />
          </span>
        </div>
      </div>
    );
  }
}

export default ProductGridList;




// WEBPACK FOOTER //
// ./src/components/Shop/ProductGridList/ProductGridList.jsx